var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeutralSentiment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_282_48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.3832 0 0 5.3832 0 12C0 18.6168 5.3832 24 12 24C18.6168 24 24 18.6168 24 12C24 5.3832 18.6168 0 12 0ZM12 21.8182C6.58625 21.8182 2.18182 17.4137 2.18182 12C2.18182 6.58625 6.58625 2.18182 12 2.18182C17.4137 2.18182 21.8182 6.58625 21.8182 12C21.8182 17.4137 17.4137 21.8182 12 21.8182Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7027 14.6118H8.29731C7.69484 14.6118 7.20641 15.1002 7.20641 15.7027C7.20641 16.3052 7.69484 16.7936 8.29731 16.7936H15.7027C16.3052 16.7936 16.7936 16.3052 16.7936 15.7027C16.7936 15.1002 16.3052 14.6118 15.7027 14.6118Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37382 10.7011C8.6451 10.4305 8.80001 10.0553 8.80001 9.67273C8.80001 9.29019 8.6451 8.91491 8.37382 8.64429C8.10328 8.37382 7.72801 8.21819 7.34546 8.21819C6.96212 8.21819 6.58764 8.37382 6.31702 8.64429C6.04582 8.91491 5.89091 9.28939 5.89091 9.67273C5.89091 10.0553 6.04582 10.4305 6.31702 10.7011C6.58764 10.9716 6.96291 11.1273 7.34546 11.1273C7.72801 11.1273 8.10328 10.9716 8.37382 10.7011Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6545 8.21819C16.2713 8.21819 15.8967 8.37382 15.6261 8.64429C15.3556 8.91491 15.2 9.28939 15.2 9.67273C15.2 10.056 15.3556 10.4305 15.6261 10.7011C15.8967 10.9716 16.272 11.1273 16.6545 11.1273C17.0371 11.1273 17.4124 10.9716 17.6829 10.7011C17.9535 10.4305 18.1091 10.0553 18.1091 9.67273C18.1091 9.29019 17.9534 8.91491 17.6829 8.64429C17.4124 8.37382 17.0378 8.21819 16.6545 8.21819Z",
    fill: "#FFA000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_282_48"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralSentiment);
export default __webpack_public_path__ + "static/media/neutralSentiment.6a61b3af036a600376687c686771b386.svg";
export { ForwardRef as ReactComponent };